<template>
    <Dialog
            v-model="show"
            :title="getTitle"
            :show-close-button="true"
            :options="{ width: '45%', height: '95%' }"
            :buttons="buttons"
            @close="fecharDialog"
    >
        <div class="grid-dialog-3">
            <div v-for="(field, i) in schema" :key="i" class="input-wrapper-dialog">
                <component
                        :is="getComponentType(field)"
                        v-model="form[field.model]"
                        v-bind="field.props"
                        auto-grow="false"
                        outlined dense
                        maxlength="255"
                        v-input-filter="field.type === 'input' ? [$filters.text] : undefined"
                        :rules="formSubmitted ? [required] : []"
                />
            </div>
        </div>
        <v-divider class="mt-4 mb-4"></v-divider>

        <div v-if="checkboxes.length" class="section-title-check">
            Funcionalidades Administrativas
        </div>
        <div class="checkbox-container-dialog">
            <div
                    v-for="(column, colIndex) in checkboxColumns"
                    :key="`col-${colIndex}`"
                    class="checkbox-column-dialog"
            >
                <v-checkbox
                        v-for="(chk, i) in column"
                        :key="`${colIndex}-${i}`"
                        v-model="form.selectedPermissions"
                        :label="chk.label"
                        :value="chk.value"
                        color="secondary"
                        hide-details
                        dense
                />
            </div>
        </div>
    </Dialog>
</template>

<script>
  export default {
    name: 'DialogPermissoesPerfilAdministrativo',
    props: {
      value: { type: Boolean, default: false },
      showCloseButton: { type: Boolean, default: true },
      title: { type: String, default: '' },
      schema: { type: Array, default: () => [] },
      checkboxes: { type: Array, default: () => [] },
      isEdit: { type: Boolean, default: false },
      perfil: { type: Object, default: null }
    },
    data () {
      const form = { selectedPermissions: [] }
      this.schema.forEach(field => {
        if (field.model === 'status') {
          form[field.model] = 0
        } else if (field.model === 'permissao') {
          form[field.model] = 0
        } else {
          form[field.model] = field.type === 'select' ? null : ''
        }
      })
      return {
        form,
        formSubmitted: false,
        required: v => (v !== null && v !== undefined && v !== '') || 'Campo obrigatório'
      }
    },
    computed: {
      show: {
        get () { return this.value },
        set (val) { this.$emit('input', val) }
      },
      buttons () {
        return {
          [this.isEdit ? 'EDITAR' : 'CRIAR']: {
            handler: this.onSubmit,
            disabled: !this.formValido
          }
        }
      },
      checkboxColumns () {
        const columns = []
        const itemsPerColumn = 10
        for (let i = 0; i < this.checkboxes.length; i += itemsPerColumn) {
          columns.push(this.checkboxes.slice(i, i + itemsPerColumn))
        }
        return columns
      },
      formValido () {
        for (const field of this.schema) {
          if (this.form[field.model] === null || this.form[field.model] === '') {
            return false
          }
        }
        if (!this.form.selectedPermissions || this.form.selectedPermissions.length === 0) {
          return false
        }
        return true
      },
      getTitle () {
        if (this.title) return this.title
        return this.isEdit ? 'Editar Perfil' : 'Adicionar Perfil'
      }
    },
    watch: {
      show (val) {
        if (val && this.perfil) {
          this.form.nome = this.perfil.nome
          this.form.status = this.perfil.status
          this.form.permissao = this.perfil.permissao
          this.form.selectedPermissions = Array.isArray(this.perfil.selectedPermissions)
            ? [...this.perfil.selectedPermissions]
            : []
        }
        if (!val) this.resetForm()
      }
    },
    methods: {
      getComponentType (field) {
        switch (field.type) {
          case 'input': return 'v-text-field'
          case 'select': return 'v-select'
          default: return 'v-text-field'
        }
      },
      fecharDialog () {
        this.show = false
         this.formSubmitted = false
        if (!this.perfil) {
          this.resetForm()
        }
      },
      resetForm () {
        this.schema.forEach(field => {
          this.form[field.model] = field.type === 'select' ? 0 : ''
        })
        this.form.selectedPermissions = []
        this.formSubmitted = false
      },
      onSubmit () {
        this.formSubmitted = true
        if (this.formValido) {
          this.$emit('submit', {
            ...this.form
          })
        }
        this.show = false
      }
    }
  }
</script>

<style scoped>
.grid-dialog-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 20px;
  align-items: start;
}

/* wrapper para inputs menores */
.input-wrapper-dialog .v-input.v-input--dense .v-input__slot,
.input-wrapper-dialog .v-select.v-input--dense .v-input__slot,
.input-wrapper-dialog .v-textarea.v-input--dense .v-input__slot {
  min-height: 30px !important;
  font-size: 13px;
}

/* ajusta padding interno para inputs e selects */
.input-wrapper-dialog .v-input.v-input--dense .v-input__control,
.input-wrapper-dialog .v-select.v-input--dense .v-input__control,
.input-wrapper-dialog .v-textarea.v-input--dense .v-input__control {
  padding-top: 4px;
  padding-bottom: 4px;
}

/* botão de adicionar com fundo verde */
.btn-permissao {
  background-color: var(--secondary) !important;
  color: white !important;
}

/* título acima dos checkboxes */
.section-title-check {
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 14px;
  color: #444;
}

/* container dos checkboxes em colunas */
.checkbox-container-dialog {
  margin-top: 10px;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

/* cada coluna de checkboxes */
.checkbox-column-dialog {
  display: flex;
  flex-direction: column;
  min-width: 180px;
  flex: 1;
}

/* media queries */
@media (max-width: 960px) {
  .grid-dialog-3 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .grid-dialog-3 {
    grid-template-columns: 1fr;
  }
}
</style>
